export default __webpack_public_path__ + "media/Waffle.d1794389.svg";